/* Valid chartType values for MetricsSummary */
export default {
  YEARLY: 'yearly',
  ITEMIZED: 'itemized',
  SIMPLE_PIE: 'simplePie',
};
